import script from "./TarjetaHomeMejoresApresSkis.vue?vue&type=script&setup=true&lang=js"
export * from "./TarjetaHomeMejoresApresSkis.vue?vue&type=script&setup=true&lang=js"

import "./TarjetaHomeMejoresApresSkis.vue?vue&type=style&index=0&id=2b218dfb&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b218dfb"]])

export default __exports__